<!-- 营收反查 -->
<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed ? 0 : 5" :sm="24" class="new-col">
      <a-row :gutter="10" class="new-row">
        <a-card :bordered="false" class="new-tree-card">
          <AreaTreeCard
            ref="areaTreeCard"
            :area-loading="areaLoading"
            :area-tree="areaTree"
            :curr-selected="currSelected"
            @node-selected="handleNodeSelected"
            @node-unselected="handleNodeUnselected"
            @unselect="resetAareaData"
            @collapse-all="collapseTree"
            @area-add="handleAreaAdd"
            @add-child="handleAdd"
            @delete="handleDelete"
            @toggle-visibility="handleTreeToggle"
          />
        </a-card>
      </a-row>
    </a-col>
    <a-col :md="collapsed ? 24 : 19" :sm="24" style="position: relative; padding-left: 30px" class="new-col">
      <a-icon
        :type="collapsed ? 'caret-right' : 'caret-left'"
        @click="collapsed = !collapsed"
        class="area-collapsed"
      ></a-icon>
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('月份')">
                  <a-month-picker
                    v-model="queryParam.date"
                    value-format="YYYY-MM"
                    :placeholder="$t('请选择月份')"
                    style="width: 100%"
                  />
                </a-form-item>
              </a-col>
              <!-- <a-col :xl="8" :lg="7" :md="8" :sm="24">
                <a-form-item label="口径">
                  <a-input-number v-model="queryParam.caliber" placeholder="请输入口径" style="width: 100%" />
                </a-form-item>
              </a-col> -->
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: true }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange"
          >
          </a-table>
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>
            
    <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import JInput from '@/components/jeecg/JInput'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import AreaTreeCard from '../AreaTreeCard.vue'
import axios from 'axios'
export default {
  name: 'RevenueCounterCheck',
  mixins: [JeecgListMixin, AreaChoosetMixin, mixinDevice],
  components: {
    JInput,
    AreaTreeCard,
  },
  data() {
    return {
      description: '供水量分析',
      collapsed: false,
      url: {
        list: '/mock/RevenueCounterCheck',
      },
      date: [],
      dataSource1: [
        {
          id: 1,
          userCode: 14497499,
          userName: '彭杰',
          meterId: 2853219521,
          month: '2025-07',
          lastReadTime: '2025-07-01 18:01:05',
          currentReadTime: '2025-07-02 18:05:06',
          readDays: 0,
          lastReadNumber: 0,
          currentReadNumber: 0,
          currentWaterUsage: 0,
          lastWaterUsage: 0,
        },
        {
          id: 2,
          userCode: 43894013,
          userName: '尹洋',
          meterId: 6336459789,
          month: '2025-03',
          lastReadTime: '2025-03-01 06:52:01',
          currentReadTime: '2025-03-05 17:57:01',
          readDays: 0,
          lastReadNumber: 0,
          currentReadNumber: 0,
          currentWaterUsage: 0,
          lastWaterUsage: 0,
        },
        {
          id: 3,
          userCode: 85984854,
          userName: '江丽',
          meterId: 1997133282,
          month: '2025-07',
          lastReadTime: '2025-07-01 16:04:05',
          currentReadTime: '2025-07-15 12:05:06',
          readDays: 0,
          lastReadNumber: 0,
          currentReadNumber: 0,
          currentWaterUsage: 0,
          lastWaterUsage: 0,
        },
        {
          id: 4,
          userCode: 22311168,
          userName: '杨杰',
          meterId: 6802212679,
          month: '2025-01',
          lastReadTime: '2025-01-01 21:54:00',
          currentReadTime: '2025-01-21 21:20:00',
          readDays: 0,
          lastReadNumber: 0,
          currentReadNumber: 0,
          currentWaterUsage: 0,
          lastWaterUsage: 0,
        },
        {
          id: 5,
          userCode: 22983350,
          userName: '金涛',
          meterId: 8445522357,
          month: '2025-07',
          lastReadTime: '2025-07-08 08:51:00',
          currentReadTime: '2025-07-10 09:01:34',
          readDays: 0,
          lastReadNumber: 0,
          currentReadNumber: 0,
          currentWaterUsage: 0,
          lastWaterUsage: 0,
        },
        {
          id: 6,
          userCode: 89179599,
          userName: '范洋',
          meterId: 9393156757,
          month: '2025-02',
          lastReadTime: '2025-02-09 09:21:30',
          currentReadTime: '2025-02-09 09:52:09',
          readDays: 0,
          lastReadNumber: 0,
          currentReadNumber: 0,
          currentWaterUsage: 0,
          lastWaterUsage: 0,
        },
      ],
    }
  },
  created() {},
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('序号'),
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('用户编号'),
          align: 'center',
          dataIndex: 'userCode',
        },
        {
          title: this.$t('用户名称'),
          align: 'center',
          dataIndex: 'userName',
        },
        {
          title: this.$t('表编号'),
          align: 'center',
          dataIndex: 'meterId',
        },
        {
          title: this.$t('月份'),
          align: 'center',
          dataIndex: 'month',
        },
        {
          title: this.$t('上次抄读时间'),
          align: 'center',
          dataIndex: 'lastReadTime',
        },
        {
          title: this.$t('本次抄读时间'),
          align: 'center',
          dataIndex: 'currentReadTime',
        },
        {
          title: this.$t('抄表天数'),
          align: 'center',
          dataIndex: 'readDays',
        },
        {
          title: this.$t('上次抄表读数'),
          align: 'center',
          dataIndex: 'lastReadNumber',
        },
        {
          title: this.$t('本次抄表读数'),
          align: 'center',
          dataIndex: 'currentReadNumber',
        },
        {
          title: this.$t('本月用水量'),
          align: 'center',
          dataIndex: 'currentWaterUsage',
        },
        {
          title: this.$t('上月用水量'),
          align: 'center',
          dataIndex: 'lastWaterUsage',
        },
      ]
    },
  },
  methods: {
    // async loadData() {
    //   try {
    //     let params = this.getQueryParams()
    //     params.startDate = this.date[0]
    //     params.endDate = this.date[1]
    //     const res = await axios.post(this.url.list, params)
    //     if (res.data.code == 200) {
    //       this.dataSource = res.data.result.records
    //       this.ipagination.total = res.data.result.total
    //     } else {
    //       this.dataSource = []
    //       this.ipagination.total = 0
    //       this.$message.error(res.data.message)
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },
    loadData() {
      if(this.queryParam.date) {
        this.dataSource = this.dataSource1.filter(item => item.month == this.queryParam.date)
      }else{
        this.dataSource = this.dataSource1
      }
    },
  },
}
</script>
            <style scoped>
@import '~@assets/less/common.less';
</style>